// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"92d2402f","581":"1c70bbcc"}[chunkId] + ".chunk.js";
};